import { IconButton, TextField } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import React, { useEffect, useState } from 'react';
import PhoneIcon from '@material-ui/icons/Phone';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import './style.css';
import LanguageDropdown from '../../UI/LanguageDropdown/LanguageDropdown';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { auth } from '../../../firebase-init';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Text from '../../UI/Text/Text';
import Avatar from 'react-avatar';

const Header = ({ openSidebar, setOpenSidebar, user, firstName }) => {
  const { t, i18n } = useTranslation();
  let history = useHistory();
  let location = useLocation();
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Scroll effect logic
  useEffect(() => {
    const controlHeader = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY < lastScrollY || currentScrollY < 100) {
        // Scrolling up or near top - show header
        setIsHeaderVisible(true);
      } else {
        // Scrolling down - hide header
        setIsHeaderVisible(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', controlHeader);
    return () => window.removeEventListener('scroll', controlHeader);
  }, [lastScrollY]);

  const goToBooks = () => {
    history.push('/books/');
  };

  const goToPNST = () => {
    window.open('https://www.pnst.cerist.dz/recherche.php', '_blank');
  };

  const goToINAPI = () => {
    history.push('/publications/conference-proceedings');
  };

  const goToArabicCouncil = () => {
    history.push('/publications/council-books');
  };

  const goToCNERH = () => {
    history.push('/publications/cnerh');
  };

  const goToHome = () => {
    history.push('/');
  };

  const goToProfile = () => {
    history.push('/profile');
  };

  const logout = () => {
    auth.signOut();
  };

  return (
    <header className={`header-container ${isHeaderVisible ? 'header-visible' : 'header-hidden'}`}>
      <nav className="navbar navbar-light bg-light modern-header">
        <div className="top-container">
          <div className="container">
            <div className="row w-100 desktop">
              <div className="col-lg-3 col-md-4 logo-container">
                <img className="logo" src="/assets/images/logo.png" alt="" onClick={goToHome} />
              </div>
              <div className="col-lg-6 col-md-5 navigation-container">
                <ul className="menu-item-container">
                  <Link to="/" className={location.pathname === '/' ? 'menu-item active' : 'menu-item'}>
                    {t('header.home')}
                  </Link>
                  <Link to="/books" className={location.pathname.includes('/books') ? 'menu-item active' : 'menu-item'}>
                    {t('header.books')}
                  </Link>
                  <li className="menu-item">
                    <span 
                      onClick={goToPNST}
                      style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'none' }}
                      title={t('publicationsDropdown.researchPapers')}
                    >
                      {t('header.pnstShort')}
                    </span>
                  </li>
                  <li className="menu-item">
                    <span 
                      onClick={goToINAPI}
                      style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'none' }}
                      title={t('publicationsDropdown.conferenceProceedings')}
                    >
                      {t('header.inapiShort')}
                    </span>
                  </li>
                  <li className="menu-item">
                    <span 
                      onClick={goToArabicCouncil}
                      style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'none' }}
                      title={t('publicationsDropdown.councilBooks')}
                    >
                      {t('header.conseilArabeShort')}
                    </span>
                  </li>
                  <li className="menu-item cnerh-tab">
                    <span 
                      onClick={goToCNERH}
                      style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'none' }}
                      title={t('header.cnerh')}
                    >
                      {t('header.cnerhShort')}
                    </span>
                  </li>
                  <li className="menu-item">
                    <Link
                      to="/publications/el-madjlis-hci"
                      className={location.pathname === '/publications/el-madjlis-hci' ? 'menu-item active' : 'menu-item'}
                      title={t('header.elMadjlisHci')}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      {t('header.elMadjlisHci')}
                    </Link>
                  </li>
                  <li className="menu-item">
                    <div className="dropdown">
                      <span 
                        className="dropdown-toggle" 
                        role="button" 
                        id="publicationsDropdown" 
                        data-bs-toggle="dropdown" 
                        aria-expanded="false"
                        style={{ cursor: 'pointer', color: 'inherit', textDecoration: 'none' }}
                      >
                        {t('header.publications')}
                      </span>
                      <ul className="dropdown-menu" aria-labelledby="publicationsDropdown">
                        <li>
                          <Link 
                            to="/publications/books" 
                            className="dropdown-item"
                          >
                            {t('publicationsDropdown.books')}
                          </Link>
                        </li>
                        <li>
                          <a 
                            href="https://www.echaab.dz/journal-archive/" 
                            className="dropdown-item"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {t('publicationsDropdown.reports')}
                          </a>
                        </li>
                        <li>
                          <a 
                            href="https://www.horizons.dz/category/archives-pdf/" 
                            className="dropdown-item"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {t('publicationsDropdown.horizonsJournal')}
                          </a>
                        </li>
                        <li>
                          <a 
                            href="https://aala.dz/%d8%a7%d9%84%d9%85%d9%86%d8%b4%d9%88%d8%b1%d8%a7%d8%aa/%d9%85%d9%86%d8%b4%d9%88%d8%b1%d8%a7%d8%aa-%d8%a3%d8%ae%d8%b1%d9%89/" 
                            className="dropdown-item"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {t('publicationsDropdown.aalaPublications')}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <Link to="/contact" className={location.pathname === '/contact' ? 'menu-item active' : 'menu-item'}>
                    {t('header.contact')}
                  </Link>
                </ul>
              </div>
              <div className="col-lg-3 col-md-3 call-navbar-container">
                {user !== null ? (
                  <div className="dropdown">
                    <a
                      className="dropdown-toggle profile-header-dropdown"
                      href="#"
                      role="button"
                      id="dropdownMenuLink"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <Avatar name={user.name} size="40" round={true} />
                      &nbsp;&nbsp;
                      {user && <Text text={firstName} maxLength={15} />}
                    </a>

                    <ul className="dropdown-menu p-2 w-100" aria-labelledby="dropdownMenuLink">
                      <li className="dropdown-item" onClick={goToProfile}>
                        {t('header.update-profile')}
                      </li>
                      <li className="dropdown-item" onClick={logout}>
                        {t('header.logout')}
                      </li>
                    </ul>
                  </div>
                ) : (
                  <div className="d-flex justify-content-end align-items-center gap-3">
                    <Link
                      to="/login"
                      className="btn btn-warning btn-sm font-weight-bold"
                    >
                      {t('login.form.connect')}
                    </Link>
                  </div>
                )}
                <div className="language-dropdown-container">
                  <LanguageDropdown />
                </div>
              </div>
            </div>
            {/* ############### mobile ############### */}
            <div className="w-100 mobile">
              <div className="logo-container ">
                <img className="logo" src="/assets/images/logo.png" alt="" onClick={goToHome} />
              </div>
              <div className="button-sidebar">
                <MenuIcon onClick={() => setOpenSidebar(true)} />
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
